package ld;

import pixi.core.display.Container;
import pixi.core.graphics.Graphics;
import pixi.extras.BitmapText;
import tweenx909.TweenX;
import stocking.ColoredBitmapText;
import stocking.AudioManager;

class NotificationWindow
{
	var size = { x: 321, y: 0};
	var openSize = {x: 321, y: 37};
	var closedSize = {x: 321, y: 0};
	var middle = {x: 160, y: 18 };

	var padding = { x: 10, y: 5 };

	var notificationQueue = new Array<String>();

	var container : Container;
	var containerGraphics  = new Container();
	var containerText = new Container();
	var g : Graphics;

	public function new( containerRoot : Container )
	{
		container = containerRoot;

		container.addChild(containerGraphics);
		container.addChild(containerText);
		g = new Graphics();
		containerGraphics.addChild(g);
	}

	public function IsBusy()
	{
		return size.y > 0;
	}

	public function ShowTextOrClose()
	{
		containerText.removeChildren();
		if(notificationQueue.length > 0 )
		{
			AudioManager.instance.play("notif");
			var n = notificationQueue.pop();
			var text = new ColoredBitmapText( n, { font: "12px khdot12" } );
			text.x = padding.x;
			text.y = padding.y;

			containerText.addChild(text);

			TweenX.to( text, { alpha: 0 } ).delay( 2.5 ).time(0.5).onFinish( ShowTextOrClose );
		}
		else 
		{
			TweenX.to( size, { x: closedSize.x, y: closedSize.y } ).time(0.2).onFinish(ShowNotificationIfNecessary);
		}
		
	}

	public function ShowNotification( n : String )
	{
		notificationQueue.push( n );
		
		if( IsBusy() )
			return;

		ShowNotificationIfNecessary();
		
	}

	public function ShowNotificationIfNecessary()
	{
		if( notificationQueue.length > 0 )
			TweenX.to( size, { x: openSize.x, y: openSize.y } ).time(0.2).onFinish( ShowTextOrClose );
	}

	public function Tick( delta : Float )
	{
		
		// Draw out thing
		g.clear();
		
		
		if( IsBusy() )
		{
			g.lineStyle(0);
			g.beginFill(0);
			g.drawRect( middle.x - size.x / 2, middle.y - size.y / 2 - 2, size.x, size.y + 4 );
			g.lineStyle(1., 0xFFFFFF);
			g.beginFill(0);
			g.drawRect( middle.x - size.x / 2, middle.y - size.y / 2, size.x, size.y );
		}
		
		

	}
}